export default {
    "ControlPage": 'spare/WorkbenchWrap.vue',//工作台
    "CommandSystem": 'CommandSystem.vue',//指挥体系
    "SmartEnergy": 'SmartEnergy.vue',//智慧能源


    /*     能源管理    icon: 'icon-el-energy'  */
    "EnergyManagement": 'nengyuanguanli/EnergyManagement.vue',//能源管理
    "EquipmentConsume": 'nengyuanguanli/EquipmentConsume.vue',//设备能耗
    "EbnormalEnergy": 'nengyuanguanli/EbnormalEnergy.vue',//异常用能
    "AddedEnergy": 'nengyuanguanli/AddEquipment.vue',//新增用能
    "RunTimeStatistics": 'nengyuanguanli/RunTimeStatistics.vue',//运行时间
    "SangiAnalysis": 'nengyuanguanli/EnergySankey.vue',//桑基分析
    "YoyAnalysis": 'nengyuanguanli/YoyAnalysis.vue',//同比分析
    "RingAnalysis": 'nengyuanguanli/RingAnalysis.vue',//环比分析
    //"EnergySearch": 'nengyuanguanli/EnergySearch.vue',//能耗查询
    "ECMeterReading": 'nengyuanguanli/ECMeterReading.vue',//能耗集抄
    "ECAnalysis": 'nengyuanguanli/ECAnalysis.vue',//能耗分析




    /*     设备管理   icon: 'icon-el-equipment'   */
    "EquipmentStatus": 'shebeiguanli/EquipmentStatus.vue',//设备状态
    "Equipmentmanagement": 'shebeiguanli/EquipmentManagement.vue',//设备管理
    "EquipmentContrast": 'shebeiguanli/EquipmentContrast.vue',//设备对比
    "AlarmManagement": 'shebeiguanli/AlarmManagement.vue',//报警管理
    "AlarmAnalysis": 'shebeiguanli/AlarmAnalysis.vue',//报警分析




    /*     子系统   icon: 'icon-el-system'   */
    // 照明系统
    "LightingSystem": 'zixitong/LightingSystem/LightingSystem.vue',//照明系统
    "Console": 'zixitong/LightingSystem/ConsoleCom.vue',//系统控制
    "SystemDevice": 'zixitong/LightingSystem/SystemDevice.vue',//照明系统-系统设备
    "LightingEnergy": "zixitong/LightingSystem/LightingEnergy.vue",//用能分析
    //"LightingYOM": 'zixitong/LightingYOM.vue',//同比环比
    //"PowerDensity": 'zixitong/PowerDensity.vue',//功率密度

    // 空调系统
    "AirSystem": 'zixitong/AirConditioningSystem/AirSystem.vue',//空调系统
    "Controls": 'zixitong/AirConditioningSystem/ControlsCom.vue',//系统控制
    "AirEnergy": 'zixitong/AirConditioningSystem/AirEnergy.vue',//用能分析
    "Air3DModel": 'zixitong/AirConditioningSystem/Air3DModel.vue',//3D控制模型
    "AirEfficiency": 'zixitong/AirConditioningSystem/AirEfficiency.vue',//能效分析

    // 光伏系统
    "PhotovoltaicMain": 'zixitong/PhotovoltaicSystem/PhotovoltaicMain.vue',//光伏主页
    "PhotovoltaicSystem": 'zixitong/PhotovoltaicSystem/PhotovoltaicSystem.vue',//光伏系统
    "PhotovoltaicBenefits": 'zixitong/PhotovoltaicSystem/PhotovoltaicBenefits.vue',//光伏效益
    "PhotovoltaicDiagram": 'zixitong/PhotovoltaicSystem/PhotovoltaicDiagram.vue',//配电图
    "PhotovoltaicStation": "zixitong/PhotovoltaicSystem/PhotovoltaicStation",//光伏电站2.0
    "PhotovoltaicMonitor": "zixitong/PhotovoltaicSystem/PhotovoltaicMonitor",//监控管理
    "PhotovoltaicDevOps": 'zixitong/PhotovoltaicSystem/PhotovoltaicDevOps.vue',//运维管理
    "PhotovoltaicInverter": 'zixitong/PhotovoltaicSystem/PhotovoltaicInverter.vue',//逆变器
    // 环境监测
    "IndoorsDataDetails": 'zixitong/IndoorEnvironment/IndoorsDataDetails.vue',//环境监测

    // 配电系统
    "DistributionSystem":'zixitong/DistributionSystem/DistributionSystem.vue',//配电系统
    "DistributingRun":'zixitong/DistributionSystem/DistributingRun.vue',//运行状态
    "DemandAnalysis":'zixitong/DistributionSystem/DistributingRun.vue',//需量分析
    "PowerDistribution":'zixitong/DistributionSystem/PowerDistribution.vue',//配电图
    "PowerQuality":'zixitong/DistributionSystem/DistributingRun.vue',//电能质量
    "DistributingMonitor":'zixitong/DistributionSystem/DistributingMonitor.vue',//监控管理
    "DistributingDevOps":'zixitong/DistributionSystem/DistributingDevOps.vue',//运维管理
    //"MonitoringData": 'zixitong/DistributionSystem/MonitoringData.vue',//监测数据
    // "CircuitQuery": 'zixitong/DistributionSystem/CircuitQuery.vue',//回路查询

    // 建筑系统
    "BuildingInfor": 'zixitong/BuildingSystem/BuildingInfor.vue',//建筑信息
    "Building3DModel": 'zixitong/BuildingSystem/Building3DModel.vue',//3D模型

    // 生活热水系统
    "DHWSystem": 'zixitong/DHWSystem/DHWSystem.vue',//生活热水系统
    "EfficiencyAnalysis": 'zixitong/DHWSystem/EfficiencyAnalysis.vue',//能效分析
    "DHWEnergy": 'zixitong/DHWSystem/DHWEnergy.vue',//用能分析
    

    // 动力系统
    "DynamicalSystem":'zixitong/DynamicalSystem/DynamicalSystem.vue',//动力系统
    "RealTimeStatus":'zixitong/DynamicalSystem/RealTimeStatus.vue',//实时状态
    "DynamicalDevice":'zixitong/LightingSystem/SystemDevice.vue',//系统设备
    "DynamicalEnergy":'zixitong/DynamicalSystem/DynamicalEnergy.vue',//用能分析
    "DynamicalDevOps":'zixitong/DynamicalSystem/DynamicalDevOps.vue',//运维管理





    // 电梯系统
    //"LiftmModelPage": 'zixitong/ModelPage.vue',//3D模型
    // "ElevatorDetails": 'zixitong/ElevatorDetails.vue',//电梯系统详情
    //"ElevatorList": 'zixitong/ElevatorSystem/SystemHomePage.vue',//系统主页
   



    /*     报表管理   icon: 'icon-el-reportform'  */
    "EnergyReport": 'baobiaoguanli/EnergyReport.vue',//能耗报表
    "CustomReport": 'baobiaoguanli/CustomReport.vue',//自定义报表
    "ReportTemplate": 'baobiaoguanli/ReportTemplate.vue',//报表模板
    "DevOpsReport": 'baobiaoguanli/DevOpsReport.vue',//运维报表




    /*     后勤管理   icon: 'icon-el-logistics' */
    //工单管理
    "Worksheets": 'houqinguanli/Worksheets.vue',//工单管理
    "WorkOrderAnalysis": 'houqinguanli/WorkOrderAnalysis.vue',//工单分析
    // 巡检管理
    "PatrolPoint": 'houqinguanli/patrolSystem/PatrolPoint.vue',//巡检点
    "PatrolRoute": 'houqinguanli/patrolSystem/PatrolRoute.vue',//巡检路线
    "PatrolPlan": 'houqinguanli/patrolSystem/PatrolPlan.vue',//巡检计划
    "PatrolRecords": 'houqinguanli/patrolSystem/PatrolRecords.vue',//巡检记录
    //"EquipmentPatrol": 'houqinguanli/EquipmentPatrol.vue',//设备巡检
    //  保养管理
    "EquipmentMaintain": 'houqinguanli/maintenance/EquipmentMaintain',//设备保养
    "MaintainPlan": 'houqinguanli/maintenance/MaintenancePlan.vue',//保养计划
    "MaintainRecords": 'houqinguanli/maintenance/MaintenanceRecord.vue',//保养记录
    //权限管理
    "Authority": 'houqinguanli/AuthorityManagement.vue',




    /*     项目信息   icon: 'icon-el-backstage'  */

    "HistoricalMonument": 'xiangmuxinxi/ProjectInfoPublic.vue',//项目历程 
    "ProjectInformation": 'xiangmuxinxi/ProjectInfoPublic.vue',//项目资讯
    "BlogMaintenance": 'xiangmulicheng/BlogMaintenance.vue',//博客
    /*     管理制度   icon: 'icon-el-administration' */
    "RulesRegulationsUp": 'guanlizhidu/RulesRegulationsUp.vue',//规章制度
    "OperateUp": 'guanlizhidu/RulesRegulationsUp.vue',//运营要求
    "ServiceContent": 'xiangmuxinxi/ServiceContent.vue',//服务内容
    "AboutUs": 'xiangmuxinxi/AboutUs.vue',//关于我们
    "SystemDescription": 'xiangmuxinxi/ProjectInfoPublic.vue',//系统说明
    "Suggestions": 'xiangmuxinxi/ProjectInfoPublic.vue',//意见建议

    /*     日志管理    */
    "LogManagement": 'rizhiguanli/LogManagement.vue',//日志管理
}
